<template>
  <div class="landing">

    <!-- ── 네비게이션 ── -->
    <nav class="land-nav">
      <div class="land-nav-inner">
        <div class="land-logo">
          <img src="/img/logo.png" alt="제일개발 로고" class="land-logo-img" />
          <span class="land-logo-name">제일개발</span>
        </div>
        <div class="land-nav-links">
          <a href="#about"   class="nav-link">회사소개</a>
          <a href="#gallery" class="nav-link">시설</a>
          <a href="#contact" class="nav-link">연락처</a>
        </div>
      </div>
    </nav>

    <!-- ── 히어로 ── -->
    <section class="hero">
      <div class="hero-bg">
        <!-- /img/landing/hero.jpg : 공장 전경 가로 와이드샷 -->
        <img src="/img/landing/hero.jpg" alt="" class="hero-img"
             onerror="this.style.display='none'" />
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <p class="hero-badge">레미콘 전문 기업</p>
        <h1 class="hero-title">
          믿을 수 있는 품질,<br />
          <span class="hero-accent">제일개발</span>
        </h1>
        <p class="hero-desc">
          2011년 설립 이래 최고 품질의 레미콘을 생산·공급합니다.<br />
          현장의 모든 요구에 신속하고 정확하게 대응합니다.
        </p>
        <div class="hero-stats">
          <div class="hs">
            <span class="hs-num">{{ year - 2011 }}<em>년+</em></span>
            <span class="hs-label">업력</span>
          </div>
          <div class="hs-div"></div>
          <div class="hs">
            <span class="hs-num">KS<em> 인증</em></span>
            <span class="hs-label">품질 보증</span>
          </div>
        </div>
      </div>
    </section>

    <!-- ── 소개 + 서비스 ── -->
    <section id="about" class="about">
      <div class="wrap">
        <div class="about-left">
          <p class="s-tag">ABOUT US</p>
          <h2 class="s-title">신뢰와 품질로<br />함께 성장합니다</h2>
          <p class="about-desc">
            제일개발은 레미콘 생산 및 공급을 핵심 사업으로, 오랜 시간 건설 현장과 함께해 온 기업입니다.
            최신 설비와 철저한 품질 관리 시스템으로 모든 배합에서 균일한 품질을 제공하며,
            빠르고 안정적인 공급망으로 현장 공정을 차질 없이 지원합니다.
          </p>
          <ul class="about-list">
            <li><span>✓</span> KS 규격 준수 레미콘 생산</li>
            <li><span>✓</span> 자체 품질 시험실 운영</li>
            <li><span>✓</span> GPS 실시간 차량 위치 확인</li>
            <li><span>✓</span> 다양한 배합 설계 대응</li>
          </ul>
        </div>
        <div class="about-right">
          <div class="svc-cards">
            <div class="svc" v-for="s in services" :key="s.title">
              <span class="svc-icon">{{ s.icon }}</span>
              <strong>{{ s.title }}</strong>
              <p>{{ s.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ── 시설 갤러리 ── -->
    <section id="gallery" class="gallery">
      <div class="wrap">
        <p class="s-tag center">GALLERY</p>
        <h2 class="s-title center">시설 소개</h2>
        <div class="g-grid">
          <div class="g-item" v-for="p in photos" :key="p.src">
            <img :src="p.src" :alt="p.label" class="g-img"
                 @error="$event.target.parentElement.classList.add('empty')" />
            <div class="g-ph">
              <span>{{ p.icon }}</span>
              <b>{{ p.label }}</b>
              <code>{{ p.src }}</code>
            </div>
            <div class="g-cap">{{ p.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <!-- ── 연락처 ── -->
    <section id="contact" class="contact">
      <div class="wrap contact-wrap">
        <div>
          <p class="s-tag">CONTACT</p>
          <h2 class="s-title white">문의하기</h2>
          <div class="c-list">
            <div class="c-item" v-for="c in contacts" :key="c.label">
              <span class="c-icon">{{ c.icon }}</span>
              <div>
                <p class="c-label">{{ c.label }}</p>
                <p class="c-val">{{ c.val }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="map-box">
          <iframe
            src="https://maps.google.com/maps?q=충청남도+보령시+오천면+충청수영로+467&output=embed&hl=ko&z=16"
            class="map-iframe"
            allowfullscreen
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>

    <!-- ── 푸터 ── -->
    <footer class="land-footer">
      <div class="wrap footer-wrap">
        <div class="f-logo">
          <img src="/img/logo.png" alt="" class="f-logo-img" />
          <span>제일개발 주식회사</span>
        </div>
        <p class="f-copy">© {{ year }} 제일개발. All rights reserved.</p>
      </div>
    </footer>

  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      year: new Date().getFullYear(),
      services: [
        { icon: '🏗️', title: '레미콘 생산',  desc: '최신 배처 플랜트로 KS 규격에 맞는 고품질 레미콘을 생산합니다.' },
        { icon: '🚛', title: '현장 납품',    desc: '자체 믹서트럭으로 건설 현장까지 신선하고 신속하게 납품합니다.' },
        { icon: '🧪', title: '품질 관리',    desc: '자체 시험실에서 배합부터 현장 슬럼프까지 철저히 관리합니다.' },
        { icon: '📋', title: '납품 관리',    desc: '납품 이력·배합·차량 현황을 체계적으로 기록·관리합니다.' },
      ],
      photos: [
        { src: '/img/landing/plant.jpg',   icon: '🏭', label: '배처 플랜트'  },
        { src: '/img/landing/truck.jpg',   icon: '🚛', label: '레미콘 차량'  },
        { src: '/img/landing/site.jpg',    icon: '🏗️', label: '납품 현장'    },
        { src: '/img/landing/quality.jpg', icon: '🧪', label: '품질 시험실'  },
      ],
      contacts: [
        { icon: '📞', label: '대표 전화',   val: '041-931-6364' },
        { icon: '📠', label: '팩스',        val: '041-931-6365' },
        { icon: '📍', label: '주소',        val: '충청남도 보령시 오천면 충청수영로 467 제일개발(주)' },
        { icon: '🕐', label: '운영시간',    val: '평일 08:00 ~ 17:00' },
      ],
    };
  },
};
</script>

<style scoped>
* { box-sizing: border-box; }

.landing {
  font-family: 'Pretendard', 'Noto Sans KR', sans-serif;
  color: #1e293b;
  background: #fff;
}

/* ── 공통 ── */
.wrap {
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 2rem;
}
.s-tag {
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: #1d8cf8;
  text-transform: uppercase;
  margin: 0 0 0.5rem;
}
.s-title {
  font-size: clamp(1.6rem, 3vw, 2.1rem);
  font-weight: 800;
  color: #0f172a;
  line-height: 1.3;
  letter-spacing: -0.02em;
  margin: 0 0 1.25rem;
}
.s-title.white { color: #fff; }
.center { text-align: center; }

/* ── 네비 ── */
.land-nav {
  position: fixed;
  top: 0; left: 0; right: 0;
  z-index: 100;
  background: rgba(10, 15, 35, 0.88);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255,255,255,0.07);
}
.land-nav-inner {
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 2rem;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.land-logo {
  display: flex;
  align-items: center;
  gap: 9px;
}
.land-logo-img {
  height: 32px; width: 32px;
  object-fit: contain;
  border-radius: 6px;
}
.land-logo-name {
  font-size: 1.1rem;
  font-weight: 700;
  color: #fff;
}
.land-nav-links {
  display: flex;
  gap: 2rem;
}
.land-nav-links .nav-link {
  font-size: 0.88rem;
  font-weight: 500;
  color: rgba(255,255,255,0.7);
  text-decoration: none;
  transition: color 0.15s;
}
.land-nav-links .nav-link:hover { color: #fff; }

/* ── 히어로 ── */
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: #0a0f23;
  overflow: hidden;
}
.hero-bg {
  position: absolute;
  inset: 0;
}
.hero-img {
  width: 100%; height: 100%;
  object-fit: cover;
  opacity: 0.4;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, rgba(10,15,35,0.9) 40%, rgba(10,15,35,0.4) 100%);
}
.hero-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 2rem;
  padding-top: 60px;
}
.hero-badge {
  display: inline-block;
  padding: 0.3rem 0.85rem;
  background: rgba(29,140,248,0.18);
  border: 1px solid rgba(29,140,248,0.38);
  color: #60a5fa;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  margin-bottom: 1.1rem;
}
.hero-title {
  font-size: clamp(2.2rem, 5vw, 3.6rem);
  font-weight: 800;
  color: #fff;
  line-height: 1.2;
  letter-spacing: -0.03em;
  margin: 0 0 1rem;
}
.hero-accent { color: #1d8cf8; }
.hero-desc {
  font-size: 1rem;
  color: rgba(255,255,255,0.65);
  line-height: 1.8;
  max-width: 480px;
  margin-bottom: 2.5rem;
}
.hero-stats {
  display: flex;
  align-items: center;
  gap: 0;
}
.hs {
  display: flex;
  flex-direction: column;
  padding: 0 2.5rem 0 0;
}
.hs:first-child { padding-left: 0; }
.hs-num {
  font-size: 1.8rem;
  font-weight: 800;
  color: #fff;
  line-height: 1;
}
.hs-num em {
  font-size: 1rem;
  font-style: normal;
  color: #1d8cf8;
  font-weight: 600;
}
.hs-label {
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 0.3rem;
}
.hs-div {
  width: 1px;
  height: 36px;
  background: rgba(255,255,255,0.15);
  margin: 0 2.5rem 0 0;
}

/* ── 소개 ── */
.about {
  padding: 6rem 0;
  background: #fff;
}
.about .wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}
.about-desc {
  color: #475569;
  line-height: 1.9;
  font-size: 0.95rem;
  margin-bottom: 1.4rem;
}
.about-list {
  list-style: none;
  padding: 0; margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}
.about-list li {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #334155;
  font-size: 0.93rem;
  font-weight: 500;
}
.about-list li span { color: #1d8cf8; font-weight: 700; }
.svc-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}
.svc {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1.4rem;
  transition: all 0.2s;
}
.svc:hover {
  border-color: #bfdbfe;
  box-shadow: 0 6px 20px rgba(0,0,0,0.06);
  transform: translateY(-2px);
}
.svc-icon { font-size: 1.8rem; display: block; margin-bottom: 0.6rem; }
.svc strong {
  display: block;
  font-size: 0.95rem;
  color: #0f172a;
  margin-bottom: 0.4rem;
}
.svc p {
  font-size: 0.82rem;
  color: #64748b;
  line-height: 1.65;
  margin: 0;
}

/* ── 갤러리 ── */
.gallery {
  padding: 5rem 0;
  background: #f8fafc;
}
.g-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-top: 2rem;
}
.g-item {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  aspect-ratio: 4/3;
  background: #dde3ef;
}
.g-img {
  width: 100%; height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
  display: block;
}
.g-item:hover .g-img { transform: scale(1.05); }
.g-item.empty .g-img { display: none; }
.g-ph {
  display: none;
  position: absolute;
  inset: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  text-align: center;
  padding: 1rem;
  background: linear-gradient(135deg, #dde3ef, #c8d1e0);
}
.g-item.empty .g-ph { display: flex; }
.g-ph span { font-size: 2rem; }
.g-ph b { font-size: 0.85rem; color: #334155; }
.g-ph code {
  font-size: 0.7rem;
  color: #64748b;
  background: rgba(0,0,0,0.07);
  padding: 0.15rem 0.5rem;
  border-radius: 4px;
}
.g-cap {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  padding: 0.55rem 0.8rem;
  background: linear-gradient(transparent, rgba(0,0,0,0.55));
  color: #fff;
  font-size: 0.8rem;
  font-weight: 600;
}

/* ── 연락처 ── */
.contact {
  padding: 5rem 0;
  background: #0f172a;
}
.contact-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: start;
}
.contact .s-tag { color: #60a5fa; }
.c-list {
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
  margin-top: 0.5rem;
}
.c-item {
  display: flex;
  align-items: flex-start;
  gap: 0.9rem;
}
.c-icon { font-size: 1.3rem; margin-top: 2px; }
.c-label {
  font-size: 0.72rem;
  color: #64748b;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0 0 0.15rem;
}
.c-val {
  font-size: 0.97rem;
  color: #e2e8f0;
  font-weight: 600;
  margin: 0;
}
.map-box {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  aspect-ratio: 4/3;
  background: #1e293b;
}
.map-iframe {
  width: 100%;
  height: 100%;
  border: 0;
  display: block;
}

/* ── 푸터 ── */
.land-footer {
  background: #080d1e;
  padding: 1.5rem 0;
}
.footer-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.f-logo {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #e2e8f0;
  font-size: 0.9rem;
  font-weight: 600;
}
.f-logo-img {
  height: 26px; width: 26px;
  object-fit: contain;
  border-radius: 4px;
}
.f-copy {
  font-size: 0.8rem;
  color: #475569;
  margin: 0;
}

/* ── 반응형 ── */
@media (max-width: 900px) {
  .about .wrap { grid-template-columns: 1fr; gap: 2.5rem; }
  .contact-wrap { grid-template-columns: 1fr; gap: 2.5rem; }
  .g-grid { grid-template-columns: repeat(2, 1fr); }
  .svc-cards { grid-template-columns: 1fr; }
}
@media (max-width: 600px) {
  .g-grid { grid-template-columns: 1fr 1fr; }
  .hero-stats { flex-wrap: wrap; gap: 1rem; }
  .hs-div { display: none; }
  .land-nav-links { display: none; }
}
@media (max-width: 400px) {
  .g-grid { grid-template-columns: 1fr; }
}
</style>
